const QuestionnaireStatus = {
  1: 'Draft',
  2: 'Active',
  3: 'Inactive'
}

export default questionnaireStatusCode => 
  QuestionnaireStatus[questionnaireStatusCode] || 'Questionnaire status not mapped yet'
